import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Chip from '@mui/material/Chip';

import ItineraryBuilderTravelersSelector from './ItineraryBuilderTravelersSelector';
import ItineraryBuilderDateSelector from './ItineraryBuilderDateSelector';
import SettingsButton from './SettingsButton';
import RegionSelector from './RegionSelector';
import ResetItineraryButton from './ResetItineraryButton';
import { useBuilderStore } from './store';

const useStyles = makeStyles({
  root: {
    padding: '23px 0',
    marginBottom: 23,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 18,
    border: '1px solid #E9E1D7',
    flexWrap: 'wrap',
  },
  banner: {
    //flex: '1 1 100%',
    border: '1px solid black',
    borderRadius: 10,
    width: '100%',
    alignItems: 'center',
    marginRight: '2em',
    marginLeft: '2em',
    color: '#221F20',
    fontSize: '14px',
    fontStyle: 'normal',
    paddingLeft: 16,
    paddingRight: 16,
    fontFamily: 'Atyp Display',
    display: 'flex',
    gap: 18,
    backgroundColor: 'white',
    '&>div': {
      fontWeight: 500,
      backgroundColor: '#f24f50',
      color: 'white',
      '&>span': {
        paddingRight: 14,
        paddingLeft: 14,
      },
    },
  },
});

const Header = () => {
  const classes = useStyles();
  const replaceBooking = useBuilderStore(state => state.data.replaceBooking);
  return (
    <div className={classes.root}>
      {replaceBooking && (
        <div className={classes.banner} data-test-id="header-warning-banner">
          <Chip label="!" color="secondary" />
          When updating a provisionally held or confirmed booking, you cannot change Travelers or move the Start Date into a different
          month. If your changes require this, please contact itrvl Support or use Copy to Builder to create a new booking.
        </div>
      )}
      <ItineraryBuilderTravelersSelector />
      <ItineraryBuilderDateSelector />
      <RegionSelector />
      <ResetItineraryButton />
      <SettingsButton />
    </div>
  );
};

export default React.memo(Header);
